import { SimsFiles } from '../../models/inputTypes/JstFields';

export const prepareSimsFiles = (list: SimsFiles[], project?: string) => {
  return list.map((item) => ({
    project: item.file?.currentFile.project?.toString() ?? project,
    fileid: item.file?.currentFile?.name ?? '',
  }));
};
